import useApiQuery from 'shared/hooks/use-api-query';
import companiesKeys from '../util/companies-keys';
import {
  PaymentMethodProps,
  PaymentTypeEnum,
} from 'modules/payment-methods/types';
import {SelectDataProps} from 'shared/types/select-data';

const useCompanyPaymentMethods = (companyId?: string) => {
  const {data = [], ...query} = useApiQuery<PaymentMethodProps[]>({
    url: `/companies/${companyId}/payments`,
    queryKey: companiesKeys.paymentMethods(companyId!),
    enabled: !!companyId,
  });

  return {
    ...query,
    data: data.map((paymentMethod) => ({
      label: `${paymentMethod.name} - ${
        paymentMethod.type === PaymentTypeEnum.IN_PERSON
          ? 'Na entrega'
          : 'Online'
      }`,
      value: paymentMethod.id,
      data: paymentMethod,
    })) as SelectDataProps<PaymentMethodProps>[],
  };
};

export default useCompanyPaymentMethods;
